<template>
  <!-- Nothing to switch between (single-facility, non-super-admin). The facility
       icon matches the switcher's so the header reads the same in both cases. -->
  <span v-if="singleFacilityScope" class="d-inline-flex align-center">
    <v-icon small color="primary" class="mr-2">
      mdi-office-building-marker
    </v-icon>
    <span class="font-weight-medium text-truncate">
      {{ currentFacility && currentFacility.name }}
    </span>
  </span>
  <!-- Switchable: a menu-button picker (current facility + searchable list). -->
  <FacilitySwitcher v-else />
</template>

<script>
import useUser from "../authentication/useUser";
import useFacility from "../authentication/useFacility";
import useAccessibleScope from "../authentication/useAccessibleScope";
import FacilitySwitcher from "./FacilitySwitcher.vue";

export default {
  name: "FacilityName",
  components: { FacilitySwitcher },
  setup() {
    const { reachesMultipleFacilities, singleFacilityScope } =
      useAccessibleScope();
    const { isFacilityManager } = useUser();
    const { currentFacility } = useFacility();

    return {
      reachesMultipleFacilities,
      singleFacilityScope,
      isFacilityManager,
      currentFacility,
    };
  },
};
</script>
